import React, { useState } from "react";
import { DashboardContainer, PageWrapper } from "../../containers";

export const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(false);

  return <PageWrapper loading={isLoading} pageContainerChildren={<DashboardContainer />} />;
};

export default Dashboard;
